import { gql } from '@apollo/client';

const SearchAreaSearchQuery = gql`
  query SearchAreaSearch($first: Int, $coordinates: String, $enabled: Boolean) {
    searchAreaSearch(
      first: $first
      coordinates: $coordinates
      enabled: $enabled
    ) {
      edges {
        node {
          name
          id
          path
          description
          statisticalAreas {
            id
          }
        }
      }
    }
  }
`;

export default SearchAreaSearchQuery;
